import i18next from '../i18n'

 export const translate = (key: string) => {  
    return i18next.t(key);
  };